import React from "react";
import "../theme.css";
import logoIcon from "../assets/logo-icon.png"; 
import heroSide from "../assets/hero-side.png";
import { useNavigate } from "react-router-dom";
export default function HeroSection() {
  const navigate = useNavigate();
  return (
    <section className="hero-wrapper">

      {/* 🔹 Top Navigation */}
      <nav className="hero-nav">
        <div className="nav-left">
          <img src={logoIcon} alt="IntelliTutor Icon" className="nav-logo" />
          <span className="nav-brand">IntelliTutor</span>
        </div>

        <div className="nav-right">
          <button className="nav-link">Solutions</button>
          <button className="nav-link">Demo</button>
        </div>
      </nav>

      {/* 🔹 Hero Content */}
      <div className="hero-container">
        
        <div className="hero-left">
          <h1>The #1 AI Academic Assistant for Schools</h1>

          <p>
            IntelliTutor helps educators and students save time, improve
            learning outcomes, and boost productivity using AI-powered tools.
          </p>

          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => navigate("/chat")}>Get Started →</button>
            <button className="btn-secondary">Book a Demo →</button>
          </div>
        </div>

        <div className="hero-right">
          <img src={heroSide} alt="IntelliTutor assisting students" className="hero-image" />
        </div>

      </div>

    </section>
  );
}
